
@if (!show) {
  <div class="v-center">
    <app-spinner></app-spinner>
  </div>
}
@if (show) {
  <div class="podcast">
    <h1>
      {{show.name}}
    </h1>
    <h2>Members-Only Podcast</h2>
    @if (entitled) {
      <div>
        <div class="podcast-box">
          <mat-form-field appearance="outline">
            <mat-label>Podcast URL (RSS)</mat-label>
            <input name="url" #urlField matInput type="text" value="{{podcastUrl}}"
              (click)="selectAll($event.target)" />
              <mat-hint>Valid as long as your membership is current</mat-hint>
            </mat-form-field>
            <div class="consume-options">
              <a matTooltip="Android" mat-icon-button color="primary" target="_blank" class="android" href="{{androidPodcastUrl}}">
                <mat-icon>android</mat-icon>
              </a>
              <a matTooltip="Apple iOS" mat-icon-button color="primary" target="_blank" class="ios" href="{{podcastUrl}}">
                <svg id="apple" version="1.1" x="0px" y="0px" viewBox="0 0 22.773 22.773"
                  style="enable-background:new 0 0 22.773 22.773;">
                  <g>
                    <g>
                <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573
                  c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" />
                        <path
                  d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334
                  c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0
                  c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019
                  c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464
                  c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648
                  c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" />
                        </g>
                      </g>
                    </svg>
                  </a>
                  <a matTooltip="RSS" mat-icon-button color="primary" target="_blank" class="generic" href="{{podcastUrl}}">
                    <mat-icon>rss_feed</mat-icon>
                  </a>
                  <a matTooltip="Copy URL" mat-icon-button color="primary" class="copy" href="javascript:;" (click)="copyUrl()">
                    <mat-icon>content_copy</mat-icon>
                  </a>
                </div>
              </div>
            </div>
          }
          @if (!entitled) {
            <div>
              <p>This version of the podcast is only available to TYT members.</p>
              @if (billingEnabled) {
                <div style="text-align: center;">
                  <a href="{{joinUrl}}" mat-raised-button color="primary">Join TYT</a>
                </div>
              }
            </div>
          }
          <br />
          <div class="actions">
            <a mat-raised-button href="javascript:;" (click)="close()">Close</a>
          </div>
        </div>
      }